<script lang="ts">
  import { InlineNotification, Tile } from "carbon-components-svelte";

  export let sizeInPercentage: number = null;
  export let canvasWidth: number = null;
  export let canvasHeight: number = null;
  export let imageSrc: string = null;
  export let feedbackColour: string = null;
</script>

<InlineNotification
  kind="info"
  title="Actual imprint size -"
  subtitle="Width: {Math.trunc(canvasWidth)} mm, Height: {Math.trunc(
    canvasHeight
  )} mm"
  hideCloseButton
/>

<div
  class="fixedDimension"
  style="height: calc(var(--guide-margin) + {canvasHeight *
    3.78 *
    (sizeInPercentage / 100)}px + 1rem);"
>
  <div class="graph">
    <div
      class="guides guides-x"
      data-measure={canvasWidth}
      style="--data-measure: {canvasWidth}"
    />
    <div
      class="guides guides-y"
      data-measure={canvasHeight}
      style="--data-measure: {canvasHeight}"
    />
    <div id="feedback" style="background-color: {feedbackColour};" />
    <img id="preview" alt="Stamp Preview" src={imageSrc} />
  </div>
</div>
